const fetchFileResponseHandler = async (response: Response) =>
  URL.createObjectURL(await response.blob());

export default fetchFileResponseHandler;
